import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

export default function Breadcrumbs({ items = [], testId = "breadcrumbs" }) {
    return (
        <nav
            aria-label="Breadcrumb"
            data-testid={testId}
            className="bg-eclipse-light border-b border-neutral-200"
        >
            <div className="container-eclipse py-3">
                <ol className="flex items-center gap-2 text-xs sm:text-sm text-eclipse-muted">
                    <li>
                        <Link
                            to="/"
                            data-testid={`${testId}-home`}
                            className="inline-flex items-center gap-1.5 hover:text-eclipse-cta transition-colors font-display font-semibold"
                        >
                            <Home className="w-3.5 h-3.5" strokeWidth={2} />
                            Inicio
                        </Link>
                    </li>
                    {items.map((it, i) => (
                        <li key={i} className="flex items-center gap-2">
                            <ChevronRight className="w-3.5 h-3.5 text-neutral-400" strokeWidth={2} />
                            {it.to && i < items.length - 1 ? (
                                <Link to={it.to} className="hover:text-eclipse-cta transition-colors font-display font-semibold">
                                    {it.label}
                                </Link>
                            ) : (
                                <span aria-current="page" className="font-display font-bold text-eclipse-primary">
                                    {it.label}
                                </span>
                            )}
                        </li>
                    ))}
                </ol>
            </div>
        </nav>
    );
}
